mutation UpdateInvestmentPoolPerformance(
  $investmentPoolPerformanceInput: InvestmentPoolPerformanceInput!
) {
  updateInvestmentPoolPerformance(
    input: { investmentPoolPerformanceInput: $investmentPoolPerformanceInput }
  ) {
    investmentPoolPerformance {
      id
      openingBalance
      closingBalance
      dividendAndInterest
      changeInMarketValue
      fees
      floatDelta
    }
  }
}
